import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useI18n } from "@/i18n/I18nContext";

export default function FAQ({ onBuy }) {
  const [open, setOpen] = useState(0);
  const { t } = useI18n();

  return (
    <section
      id="faq"
      className="relative py-24 md:py-32"
      style={{ background: "var(--cream)" }}
      data-testid="faq-section"
    >
      <div className="container-x">
        <div className="grid lg:grid-cols-[0.85fr_1.25fr] gap-12 lg:gap-16">
          <div>
            <div className="chip-num mb-4">{t.faq.chip}</div>
            <h2 className="font-display font-medium text-[2.4rem] sm:text-[3rem] lg:text-[3.6rem] leading-[1] tracking-[-0.03em] text-[var(--ink)] mb-6">
              {t.faq.h2_a}{" "}
              <span className="font-editorial-italic text-[var(--marigold)]">
                {t.faq.h2_italic}
              </span>
            </h2>
            <p className="text-[var(--muted)] text-base leading-relaxed max-w-[42ch]">
              {t.faq.p}
            </p>
            <button
              onClick={onBuy}
              className="btn-pill mt-8 bg-[var(--ink)] text-[var(--cream)] hover:bg-[var(--marigold)] hover:text-[var(--cream)]"
              data-testid="faq-buy-button"
            >
              <span>{t.faq.cta}</span>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                <path d="M5 12h14M13 5l7 7-7 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              </svg>
            </button>
          </div>

          <div data-testid="faq-accordion" className="flex flex-col">
            {t.faq.items.slice(0, 4).map((f, i) => {
              const isOpen = open === i;
              return (
                <div key={i} className="border-b border-[rgba(15,31,23,0.12)]">
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className="w-full py-6 md:py-7 flex items-center justify-between gap-6 text-left group"
                    data-testid={`faq-item-${i}`}
                  >
                    <span className="font-display text-[1.35rem] md:text-[1.55rem] leading-tight tracking-tight text-[var(--ink)] group-hover:text-[var(--marigold)] transition-colors">
                      {f.q}
                    </span>
                    <motion.span
                      animate={{ rotate: isOpen ? 45 : 0 }}
                      transition={{ duration: 0.3, ease: [0.2, 0.8, 0.2, 1] }}
                      className="shrink-0 w-9 h-9 rounded-full border border-[rgba(15,31,23,0.15)] flex items-center justify-center text-[var(--ink)]"
                    >
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                        <path d="M12 5v14M5 12h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                      </svg>
                    </motion.span>
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.4, ease: [0.2, 0.8, 0.2, 1] }}
                        className="overflow-hidden"
                      >
                        <p className="pb-7 pr-14 text-[var(--muted)] text-[15.5px] leading-[1.7] max-w-[60ch]">
                          {f.a}
                        </p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
